// Action Types
const SET_REMOTE_CONFIG = 'SET_REMOTE_CONFIG';

// Action Creators
export const setRemoteConfig = (config) => ({
  type: SET_REMOTE_CONFIG,
  payload: config
});

// Initial State
const initialState = {
  uploadDocWithPreview: null,
};

// Reducer
const remoteConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REMOTE_CONFIG:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default remoteConfigReducer; 